export default __webpack_public_path__ + "static/media/customize-icon.fe5453be.svg";